import { styled as muiStyled } from '@mui/material/styles';
import {
  Box,
  Button,
  DialogActions,
  DialogContentText,
  DialogTitle,
  TableCell,
  Typography,
} from '@mui/material';
import { abyssColors } from '@/theme/colors';

type ButtonProps = {
  contained?: boolean;
  compact?: boolean;
};

export const poiTableStyles = {
  '& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-columnHeader:focus-within, & .MuiDataGrid-columnHeader:focus': {
    outline: 'none !important',
  },
  '& .MuiDataGrid-row.Mui-selected': {
    background: 'white',
  },
  '& .MuiDataGrid-row.Mui-selected:hover': {
    background: 'white',
  },
  '& .MuiDataGrid-row:hover': {
    background: 'white',
  },
  '.selected': {
    background: '#ECEFF3 !important',
  },
  '.selected:hover': {
    background: '#ECEFF3 !important',
  },
  '& svg': {
    fontSize: '2rem !important',
  },
  '& .MuiCheckbox-root': {
    p: { sm: '4px', xl: '9px' },
  },
  cursor: 'grab',
};

export const modalStyles = {
  position: 'fixed',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  borderRadius: '8px',
  background: abyssColors.neutral[50],
  boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.15)',
  overflow: 'hidden',
  maxWidth: '472px',
  height: '100%',
  maxHeight: '457px',
};

export const paperStyles = {
  boxShadow: 'none',
};

export const headerStyles = {
  padding: '24px',
  '& h5': {
    fontSize: '1.6rem',
    fontWeight: 500,
    lineHeight: '24px',
    color: abyssColors.primary[500],
  },
  '& button': {
    padding: 0,
  },
};

export const crossIconStyles = {
  fontSize: '2.4rem',
  color: abyssColors.primary[500],
  background: 'none',
};

export const SectionTitle = muiStyled(Typography)(() => ({
  color: abyssColors.primary[500],
  fontSize: '1.2rem',
  fontWeight: 500,
}));

export const pointOfInterestTabsStyles = {
  pt: 2,
  '& .MuiTab-root': {
    padding: '0 16px',
    minWidth: 0,
    minHeight: 'min-content',
    height: '26px',
    textTransform: 'none',
    border: 'none',
  },
  '& .MuiTab-root.Mui-selected': {
    backgroundColor: `${abyssColors.primary[100]} !important`,
    borderRadius: '4px',
  },
  '& .MuiTabs-indicator': {
    height: '0rem',
    border: 'none',
  },
};

export const StyledTableCell = muiStyled(TableCell)(() => ({
  borderBottom: 'none',
  width: '14%',
  padding: '0.5rem',
}));

export const TablePaginationContainer = muiStyled(Box)(() => ({
  display: 'flex',
  justifyContent: 'flex-end',
  backgroundColor: abyssColors.primary[50],
}));

export const ActionButton = muiStyled(Button)(({ contained, compact }: ButtonProps) => ({
  padding: compact ? '0.8rem 1.2rem' : '0.8rem 1.8rem',
  height: '3.4rem',
  borderRadius: '0.4rem',
  fontSize: '1.4rem',
  background: contained ? abyssColors.primary[500] : abyssColors.neutral[50],
  color: contained ? abyssColors.neutral[50] : abyssColors.primary[500],
  boxShadow: 'none',
  textTransform: 'none',
  width: 'fit-content',
  lineHeight: 'normal',
  marginLeft: '0px !important',
  gap: '0.6rem',
  '&:disabled': {
    background: contained ? abyssColors.neutral[300] : abyssColors.neutral[50],
    color: contained ? abyssColors.neutral[50] : abyssColors.primary[300],
  },
  '&:hover': {
    background: contained ? abyssColors.primary[400] : abyssColors.neutral[50],
  },
}));

export const Header = muiStyled(DialogTitle)(() => ({
  padding: '3.2rem',
  paddingBottom: '2.4rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const SubHeading = muiStyled(DialogContentText)(() => ({
  paddingBottom: '2rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const TitleText = muiStyled(Typography)(() => ({
  fontWeight: 600,
  fontSize: '2rem',
  lineHeight: 'normal',
  color: abyssColors.primary[500],
}));

export const Footer = muiStyled(DialogActions)(() => ({
  height: '6.2rem',
  padding: '1.6rem 3.2rem',
  borderTop: '1px solid rgba(101, 130, 164, 0.20)',
}));

export const DialogActionButton = muiStyled(ActionButton)(() => ({
  fontSize: '1.2rem',
  height: '3rem',
  padding: '0px 30px',
}));

export const feedbackContainerStyles = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  py: 7,
};
